var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-button',{staticClass:"infobutton",on:{"click":_vm.onClick}},[_c('i',{staticClass:"fas fa-info-circle"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }